var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VueCarousel-slide",class:{
    'VueCarousel-slide-active': _vm.isActive,
    'VueCarousel-slide-center': _vm.isCenter,
    'VueCarousel-slide-adjustableHeight': _vm.isAdjustableHeight
  },attrs:{"tabindex":"-1","aria-hidden":!_vm.isActive,"role":"tabpanel"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030192fd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/shared/components/VueCarousel/Slide.vue
// module id = 508
// module chunks = 0 2 5 6 8 9 10 11 12